"use client";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import startsWith from 'lodash.startswith';
import { SignUpForm, ActivePlan, handleOtp, GoogleForm } from "../api/Service";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './input.css'
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

function Signup({ setIsAuthenticated }) {
  const [otp, setOtp] = useState(null)
  const [sentOtp, setSentOtp] = useState(false)
  const [email, setEmail] = useState('');
  const [nameError, setNameError] = useState(null)
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(null);
  const [error, setError] = useState(null)
  const [userError, setUserError] = useState(null)
  const [otpError, setOtpError] = useState(null)
  const [password, setPassword] = useState('');
  const [phoneNumber1, setPhoneNumber1] = useState('');
  const [passwordError, setPasswordError] = useState(null);
  const [Googlerror, setGoogleError] = useState(false)

  const [messageError, setMessageError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const clientid = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  // console.log(clientid,'idddddd')

  const navigate = useNavigate();

  // const validatePassword = (password) => {
  //   const minLength = 6;
  //   const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
  //   const digitPattern = /\d/;
  //   const alphaPattern = /[a-zA-Z]/;

  //   if (password.length < minLength) {
  //     return false;
  //   }
  //   if (!specialCharPattern.test(password)) {
  //     return false;
  //   }
  //   if (!digitPattern.test(password)) {
  //     return false;
  //   }
  //   if (!alphaPattern.test(password)) {
  //     return false;
  //   }

  //   return true;
  // };
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  const submitOtp = async () => {
    try {
      if (!formData.email || !validateEmail(formData.email)) {
        setError('Please enter your email correctly');
        return false;
      } else {
        setError(null);
        const res = await handleOtp(formData.email);  // Add await for async handling
        console.log('-------', formData.email);
        setEmail(formData.email);
        console.log("Response", res.data.data);
        if (res.data.data.success === true) {
          setSentOtp(true);
          setUserError(null)
        }
        else if (res.data.data.success === false) {
          setSentOtp(false)

        }
      }
    } catch (error) {

      if (error) {
        setUserError(error.response.data.message)
        console.log(error);
      } else {
        console.log('erororororoor', userError)
        //setUserError(null)
      }
    }
  }


  const handleOtpChange = (e) => {
    console.log(e.target.value, '--------')
    setOtp(e.target.value)
    const isValid = /^\d{6}$/.test(e.target.value);
    if (!isValid && otp !== "") {
      setOtpError('Invalid OTP')
    } else {
      setOtpError(null)
    }

  }
  const handlePhoneChange = (value) => {
    setPhoneNumber1(value)
    const isValid = /^\d{11}$/.test(value);
    if (!isValid) {
      setPhoneError('Enter Phone Number Correctly');
    } else {
      setPhoneError(null);
    }

  }

  const handleSubmit = async () => {
    setIsLoading(true)
    let valid = true;
    setEmail(formData.email)
    setPassword(formData.password)

    if (phoneError) {
      setPhoneError('Enter Phone Number Correctly')
    } else {
      setPhoneError(null)
    }
    if (formData.password !== "" && !formData.password) {
      console.log('paswordd')
      setPasswordError('Please enter a password correctly');
      valid = false;
      setIsLoading(false)
    } else {
      console.log('paswordd no')
      setPasswordError(null)
    }
    if (!formData.email || !formData.firstName || !formData.password || !formData.lastName) {
      setEmailError('Please Enter all Details')
      setIsLoading(false)
    } else {
      setEmailError(null)
    }

    if (!valid) {
      return false;
    }
    // if (!formData.firstName || !formData.lastName) {
    //   setNameError('Please Enter your Name')
    // } else {
    //   setNameError(null)
    // }
    // if (!formData.email || validateEmail(formData.email)) {
    //   setError('Please enter your email correctly')
    // } else {
    //   setError(null)
    // }

    if (!valid) {
      return false;
    }

    try {

      let payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
        //phoneNumber: phoneNumber1,
        otp: otp
      };
      if (formData.firstName || formData.email || formData.password) {
        const response = await SignUpForm(payload);

        const res = await ActivePlan();

        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName);
        navigate("/app/utilization");
        return false;
      } else {

      }
    } catch (err) {
      setIsLoading(false)
      console.log("Error Response:", err.response);
      if (err || formData) {
        setMessageError(err.response?.data?.message || 'Something went wrong. Please try again.');
      } else {
        setMessageError(null);
      }

    }
  };

  const [formData, setFormData] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    terms: false,
  });


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
    console.log(decoded, 'decodedddd')
    let payload = {
      user_email: decoded.email,
      display_name: decoded.name,
      firstName: decoded.given_name,
      lastName: decoded.family_name,
      google_id: decoded.sub

    };
    try {
      const response = await GoogleForm(payload);
      if (response) {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        const res = await ActivePlan();
        localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName);
        navigate("/app/credit-coach", {
          state: {
            openModal: true
          }
        });
      }
    } catch (error) {
      if (error) {
        setGoogleError(true)
        console.error("Error logging in with Google", error);
      } else {
        setGoogleError(false)
      }
    }
  };

  const handleGoogleLoginFailure = () => {
    console.log("Google login failed");
  };

  return (
    <div className="flex flex-col md:flex-row justify-center items-center min-h-screen bg-gray-100 p-4 font-sans">
      <div className="col-rev bg-white rounded-3xl shadow-lg p-8 max-w-5xl w-full flex flex-col md:flex-row">
        <div className="md:w-1/2 pr-8">
          <div className="flex logo-hidde items-center mb-8">
            <div className="color-d w-10 h-10 bg-purple-600 rounded-full mr-2"></div>
            <h1 className="font-size text-2xl font-bold">AI Credit Repair</h1>
          </div>
          <h2 className="p-font text-4xl font-bold mb-4">
            Repair your own credit using the power of AI
          </h2>
          <p className="text-gray-600 mb-6">
            Credit repair companies charge $90-$120 per month only to send out
            generic disputes the 3 credit bureaus can legally reject. When you
            have the best technology working for you, doing it yourself is the
            only thing that makes sense. <strong>A</strong>I Credit Repair helps
            you do it faster, cheaper, and more efficiently.
          </p>
          <div className="bg-gray-100 rounded-lg p-4 mb-6">
            <p className="font-semibold mb-2">
              With AI Credit Repair, you can also...
            </p>
            <ul className="space-y-2">
              <li className="flex items-center">
                <i className="fas fa-circle text-red-500 text-xs mr-2"></i>
                <span>Increase Your Credit Score</span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-circle text-red-500 text-xs mr-2"></i>
                <span>Remove Public Records</span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-circle text-red-500 text-xs mr-2"></i>
                <span>Send Dispute Letters Using AI</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="md:w-1/2 mt-8 md:mt-0">
          <div className="bg-gray-50 rounded-lg p-6">
            <div className="form-logo flex items-center mb-8">
              <div className="w-10 h-10 bg-purple-600 rounded-full mr-2"></div>
              <h1 className="text-2xl font-bold">AI Credit Repair</h1>
            </div>
            <h3 className="text-xl font-semibold mb-4">
              Create your AI Credit Repair Account. This account will work for
              AI Credit Repair and all other AI Credit products!
            </h3>

            {emailError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{emailError}</p>}
            {passwordError && (
              <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">
                {passwordError}
              </p>
            )}
            {Googlerror && (
              <p className="text-sm mt-1 flex justify-start gap-[8px] pl-3 items-center bg-pink-100 h-10">
                Please Try Again
              </p>
            )}
            {messageError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{messageError}</p>}
            {phoneError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{phoneError}</p>}
            {error && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{error}</p>}
            {userError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{userError}</p>}
            {otpError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{otpError}</p>}
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                {nameError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{nameError}</p>}
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  className="w-full p-2 border border-gray-300 rounded"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-4">
                {/* {nameError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{nameError}</p>} */}
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  className="w-full p-2 border border-gray-300 rounded"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {/* <div className="mb-4 "> */}

              {/* {phoneError1 && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{phoneError1}</p>} */}
              {/* <PhoneInput
                  country='us'
                  onlyCountries={['us']}
                  type="text"
                  name="phoneNumber"
                  placeholder="Phone Number*"
                  className="intelInput w-full border border-gray-300 rounded"
                  value={phoneNumber1}
                  onChange={handlePhoneChange}
                  inputStyle={{
                    borderColor: phoneError ? 'red' : undefined,
                  }}
                  required

                /> */}
              {/* </div> */}
              <div className="mb-4">
                {/* {error && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{error}</p>} */}
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address*"
                  className="w-full p-2 border border-gray-300 rounded"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>


              {/* <div> */}
                {/* {userError && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{userError}</p>} */}


                {/* <p className="mt-4">
                  {sentOtp === true ? ("OTP Sent Sucessfully Please Check Your Email") : (<a onClick={submitOtp} className="text-blue-600 underline cursor-pointer">
                    Get OTP
                  </a>)}

                </p> */}
              {/* </div> */}

              {/* <div className="mb-4"> */}

                {/* <input
                  type="text"
                  maxlength="6"
                  name="OTP"
                  placeholder="Enter OTP*"
                  className="w-full p-2 border border-gray-300 rounded"
                  value={otp}
                  onChange={handleOtpChange}
                  required
                /> */}
              {/* </div> */}

              <div className="mb-4">

                <input
                  type="password"
                  name="password"
                  placeholder="Password*"
                  className="w-full p-2 border border-gray-300 rounded"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
                {/* Span for displaying password information */}
                <span className="text-xs text-gray-500 mt-2 block">
                  Password must be at least 6 characters long, contains atleast one uppercase letter, one special character, and one number.
                </span>
              </div>

              <div className="mb-6">
                {/* <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="terms"
                    className="mr-2"
                    checked={formData.terms}
                    onChange={handleInputChange}
                    required
                  /> */}
                {/* <span className="text-sm">
                    I agree to the AI Credit Repair{" "}
                    <a href="#" className="text-blue-600 underline">
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a href="#" className="text-blue-600 underline">
                      Privacy Policy
                    </a>
                    .
                  </span> */}
                {/* </label> */}
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => handleSubmit()}
                  type="button"
                  className="w-[93%] py-3 bg-gradient-to-r from-purple-500 to-red-500 text-white rounded-lg font-semibold"
                  disabled={isLoading}
                >
                  {isLoading ? "Signing In..." : "Get started"}
                </button>
              </div>
            </form>
            <div className="py-1 mt-4 justify-center w-[100%] hidden sm:flex">
              <GoogleOAuthProvider clientId={clientid}>
                <GoogleLogin
                  text="signup_with"
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginFailure}
                />
              </GoogleOAuthProvider>
            </div>

            <p className="text-center mt-4">
              <a href="/app/login" className="text-blue-600 underline">
                Already have an AI Credit Repair Account? Log in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;